module.exports = function() {
  return new Worker(__webpack_public_path__ + "69d7c828e1f21d678365.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/worker-loader/dist/cjs.js!./js/worker/worker.js
// module id = Dshm
// module chunks = 1 2 3